import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import Sidebar from "./components/Sidebar";
import { Box } from "@mui/material";
import Login from "./pages/Login";
import Settings from "./pages/Settings";
import Loader from "./components/Loader";
import { useAppContext } from "./context/AppContext";
import ForgotPassword from "./pages/ForgotPassword";
import PrivateRoute from "./components/PrivateRoute";
import CompanySettings from "./pages/CompanySettings";
import { AUTH_PAGES, USER_ROLES } from "./utils/constants";
import Register from "./pages/Register";
import EmailVerification from "./pages/EmailVerification";
import CreateUserCompany from "./pages/CreateUserCompany";
import ProjectSettings from "./pages/ProjectSettings";
import Projects from "./pages/Projects";
import Team from "./pages/Team";
import { useEffect } from "react";
import { fetchCompanyEmployees } from "./api/users";
import TeamActivity from "./pages/TeamActivity";
import SetPassword from "./pages/SetPassword";
import LandingPage from "./pages/LandingPage";

const AppContent = () => {
  const location = useLocation();

  const isLoginPage = AUTH_PAGES.some((path) => {
    const currentPath = location.pathname.toLowerCase();
    const targetPath = path.toLowerCase();

    if (targetPath.includes(":")) {
      const regexPath = targetPath.replace(/:[^\s/]+/g, "[^/]+");
      const regex = new RegExp(`^${regexPath}$`, "i"); // 'i' flag for case-insensitive
      return regex.test(currentPath);
    }

    return currentPath === targetPath;
  });
  
  const { user, setEmployeesAppContext } = useAppContext();

  useEffect(() => {
    if (user) {
      async function loadEmployees() {
        await fetchCompanyEmployees(setEmployeesAppContext);
      }
      loadEmployees();
    }
  }, [user])

  return (
    <>
      {!isLoginPage && <Sidebar />}

      <Box sx={{ ml: !isLoginPage ? '60px' : 0, p: 0 }}>
        <Routes>
          <Route element={<PrivateRoute roles={[USER_ROLES.OWNER, USER_ROLES.ADMIN, USER_ROLES.MANAGER, USER_ROLES.EMPLOYEE]} />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/team" element={<Team />} />
            <Route path="/teamactivity" element={<TeamActivity />} />
          </Route>

          <Route element={<PrivateRoute roles={[USER_ROLES.OWNER, USER_ROLES.ADMIN]} />}>
            <Route path="/projectSettings" element={<ProjectSettings />} />
            <Route path="/companySettings" element={<CompanySettings />} />
          </Route>

          <Route element={<PrivateRoute roles={[USER_ROLES.OWNER, USER_ROLES.ADMIN, USER_ROLES.MANAGER]} />}>
            <Route path="/projects" element={<Projects />} />
          </Route>

          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/setPassword/:token" element={<SetPassword />} />
          <Route path="/forgotPassword" element={<ForgotPassword />} />
          <Route path="/emailVerification" element={<EmailVerification />} />
          <Route path="/landingPage" element={<LandingPage />} />

          <Route path="/createUserCompany" element={<CreateUserCompany />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Box>
    </>
  );
};

function App() {
  const { isLoading } = useAppContext();

  return (
    <Router>
      {isLoading && <Loader message="Loading..." />}
      <AppContent />
    </Router>
  );
}

export default App;
